<template>
  <el-container>
    <el-aside width="200px"
              style="background-color: rgb(238, 241, 246)">
      <el-menu>
        <el-menu-item index="1"
                      @click="goToProfile()">
          <i class="el-icon-info"></i>
          <span>My Profile</span>

        </el-menu-item>
        <el-menu-item index="2"
                      @click="goToFiles()">
          <i class="el-icon-upload"></i>
          <span>My Royalty Statement</span>

        </el-menu-item>
        <el-menu-item index="3"
                      @click="goToTemplates()">
          <i class="el-icon-upload"></i>
          <span>My Bank/Tax Templates</span>

        </el-menu-item>
        <el-menu-item index="4"
                      @click="goToDocuments()">
          <i class="el-icon-upload"></i>
          <span>My Bank/Tax Documents</span>

        </el-menu-item>
        <el-menu-item index="5" class="high-menu-item"
                      @click="goToMarketDocuments()">
          <i class="el-icon-upload"></i>
          <span>Marketing & Editorial <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Tips and Documents</span>

        </el-menu-item>
        <el-menu-item index="5" class="high-menu-item"
                      @click="goToFaqDocuments()">
          <i class="el-icon-upload"></i>
          <span>FAQs</span>

        </el-menu-item>

        <el-menu-item index="6" v-if="showMenu"
                      @click="goToTopics()">
          <i class="el-icon-upload"></i>
          <span>Ask Questions</span>

        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-main>
      <router-view></router-view>
    </el-main>
  </el-container>
</template>

<script>
export default {
  created() {
	  //this.getHideMenu();
    //this.form = {topic: 'default topic'};
  },
  data() {
    return {
      showMenu: true,
    }
  },

  methods: {
    getHideMenu() {

      this.axios({
        method: 'get',
        url: `/user/loginid`,
      }).then(res => {
        console.log(res.data.loginid);
        if(res.data.loginid == 1216 || res.data.loginid == 1395 || res.data.loginid == 1){
          this.showMenu = true;
        }
        else{
          this.showMenu = false;
        }
      }).catch(err => {
//console.log('catched');
        this.showMenu = false;
        //res.status(200).send();

        //return;
        //return Promise.next(err);
//        return Promise.reject(err);
      });
    },
    goToProfile() {
      this.$router.push(`/user/${localStorage.userID}/profile`);
    },
    goToTopics() {
      this.$router.push(`/user/${localStorage.userID}/topics`);
    },
    goToFiles() {
      this.$router.push(`/user/${localStorage.userID}/files`);
    },
    goToTemplates(){
      this.$router.push(`/user/${localStorage.userID}/templates`);
    },
    goToDocuments() {
      this.$router.push(`/user/${localStorage.userID}/documents`);
    },
    goToMarketDocuments() {
      this.$router.push(`/user/${localStorage.userID}/markets`);
    },
    goToFaqDocuments() {
      this.$router.push(`/user/${localStorage.userID}/faqs`);
    }
  },
};
</script>

<style lang="scss" scoped>
@import 'theme/element-variables';
.high-menu-item {
  height: 40px;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/UserLayout.vue